<template>
  <div class="ma-4 pt-6">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <!-- dialog -->
    <ClientNav />
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <med-visit-list-item
          :visits="visits"
          :isLoading="isLoading"
          :userRole="userRole"
          @on-delete-item="onDeleteItem"
          @on-show-dialog="(item) => showEventForm(item)"
          @get-visits="getVisits"
          :isAuditorRole="isAuditorRole"
        />
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>
<script>
/*eslint-disable */
import axios from "axios";
import ClientNav from "@/components/ClientNav.vue";
import ClientSide from "@/components/ClientSide.vue";
import Foot from "@/components/Footer.vue";
import addVisitDialog from "./addVisitDialog";
import medVisitListItem from "./medVisitListItem";
import { mapState, mapActions, mapGetters } from "vuex";

const url = require("../../../client_config/config").url;
const MedicalVisitService = require("../../../service/medical-visit.service");

export default {
  components: { ClientNav, ClientSide, Foot, addVisitDialog, medVisitListItem },
  data: function () {
    return {
      msg: false,
      signed: false,
      text: "",
      visits: [],
      clientID: this.$route.params.clientID,
      staffName: localStorage.getItem("Name"),
      newItem: true,
      medicalVisit: "",
      clientName: "",
    };
  },

  computed: {
    ...mapState({
      isLoading: (state) => state.medicalVisit.loading,
    }),
    userRole() {
      return (
        this.$store.state.users.user.Role === "Administration" ||
        "Program Coordinator" ||
        "Client Services Manager" ||
        "Compliance Manager" ||
        "Human Resources" ||
        "Medical Manager"
      );
    },

    isAuditorRole(){
      return localStorage.getItem("userRole") === 'Auditor'
    },

    dialog: {
      get() {
        return this.$store.state.medicalVisit.dialog;
      },
      set(val) {
        this.$store.commit("medicalVisit/SET_DIALOG", val);
      },
    },
  },

  created() {
    this.getVisits();
    let medicalVisitId = this.$route.query.view;

    if (medicalVisitId) {
      MedicalVisitService.getById(medicalVisitId).then((response) => {
        const item = {
          data: response.data.visit[0],
          newItem: false,
          show: true,
        };
        this.showDialog(item, () => {
          this.$refs["medical-visit-dialog"].onViewItem(item);
          // this.getVisits();
        });
      });
    }
  },

  methods: {
    ...mapActions({
      getVisitsItem: "medicalVisit/getItem",
      addItem: "medicalVisit/addItem",
      updateItem: "medicalVisit/updateItem",
      deleteItem: "medicalVisit/deleteItem",
      addTask: "tasks/addItem",
    }),

    async getVisits() {
      let response = await this.getVisitsItem(this.clientID);
      this.clientName = await this.$store.state.clients?.client?.Name;
      if (!response.success) {
        this.msg = true;
        this.text = "Fetching data failed";
      }

      this.visits = response.visit;
    },

    showEventForm(item) {
      const id = item.data._id;

      this.$router.push({
        path: `/medVisit/${this.clientID}/update-visit/${id}`,
        query: { newEvent: "false" },
      });
    },

    onDeleteItem(item) {
      const id = item._id;
      console.log({ id });
      confirm("Are you sure you want to delete this incident?") &&
        this.delete(id);
    },

    async delete(id) {
      axios.delete(`${url}/medicalVisits/${id}`).then((response) => {
        this.getVisits();
        if (response.status === 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The medical visit has been deleted successfully.";
      });
    },

    async onAddTasks(date) {
      const data = {
        UserId: this.$store.state.users.user._id,
        Title: "Medical Visit",
        Description: "Medical Visit",
        DueDate: "",
        Status: "New",
        CreatedDate: date,
        Staff: this.$store.state.users.user._id,
      };
      await this.addTask(data);
    },

    saveFile(file, id) {
      for (let i = 0; i < file.length; i++) {
        this.uploadFiles(file[i], id);
      }
      /*
                const formData = new FormData();
                formData.append("medical", file.uploadFile);
                formData.append("medicaldoc", file.uploadFile2);

                var ct = { headers: { "content-type": "multipart/form-data" } };
                axios
                  .post(`${url}/medicalVisits/fileUploader/${id}`, formData, ct)
                  .then((res) => {
                    if (res) {
                      this.getVisits();
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
                */
    },

    saveFile2(file, id) {
      for (let i = 0; i < file.length; i++) {
        this.uploadFiles2(file[i], id);
      }
    },

    uploadFiles(file, id) {
      const formData = new FormData();
      formData.append("medical", file);
      var ct = { headers: { "content-type": "multipart/form-data" } };
      axios
        .post(
          `${url}/medicalVisits/fileUploader/${id}/${this.clientID}`,
          formData,
          ct
        )
        .then((res) => {
          if (res) {
            this.getVisits();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    uploadFiles2(file, id) {
      const formData = new FormData();
      formData.append("medicaldoc", file);
      var ct = { headers: { "content-type": "multipart/form-data" } };
      axios
        .post(
          `${url}/medicalVisits/fileuploader2/${id}/${this.clientID}`,
          formData,
          ct
        )
        .then((res) => {
          if (res) {
            this.getVisits();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    convertKey(data) {
      const output = Object.entries(data).map(([key, value]) => [
        key[0].toUpperCase() + key.slice(1),
        value,
      ]);

      return Object.fromEntries(output);
    },

    requiredField() {
      this.msg = true;
      this.text = "Please fill out all required fields";
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
</style>
